export const motogpMail = "@motogp.com";

export const defaultContactEmail = "events@motogp.com";
